import { render } from "./BlueCircularPencilIcon.vue?vue&type=template&id=1c47401c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__